import React from 'react';
import { Dragger } from '../molecules';
import { FileDownloadDropDown } from '../../tailwind/molecules';

const UploadCard = ({ CONTENT, uploadRequest, classes = '', listHeading=[] }) => {
  return (
    <div className={'bg-white rounded-lg p-6 border border-gray-200 relative ' + classes}>
      <h1 className='font-semibold text-lg text-gray-800'>{CONTENT['title']}</h1>
      <p className='mb-0 text-gray-500 inline-block w-96'>
        {CONTENT['description']} Download the sample file and edit and then upload.
      </p>
      <div className='absolute right-8 top-8 '> 
       { CONTENT['href'].length > 1 ?   
        <FileDownloadDropDown 
          title={'Download Sample File'} 
          href={CONTENT['href']}  
          listHeading={listHeading}
        /> :
        <a href={CONTENT['href']}>
          <button className='inline-flex right-8 items-center px-4 py-2 border-2 border-gray-200 text-base font-semibold rounded-md hover:bg-blue-50 transition text-blue-700 focus:outline-none'>
            Download sample file
          </button>
        </a>}
      </div>
      <Dragger
        classes='mt-8'
        title={CONTENT['dragger_title']}
        uploadRequest={uploadRequest}
        accept='.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel'
      />
    </div>
  );
};

export default UploadCard;
